"use strict";
exports.__esModule = true;
var ElementToAdd = /** @class */ (function () {
    function ElementToAdd() {
    }
    return ElementToAdd;
}());
exports.ElementToAdd = ElementToAdd;
var AnimatedTextContainer = /** @class */ (function () {
    function AnimatedTextContainer(document, height, animationDelay) {
        if (animationDelay === void 0) { animationDelay = 100; }
        this.document = document;
        this.animationDelay = animationDelay;
        this.element = null;
        this.previousElement = null;
        this.queue = [];
        this.inProgress = false;
        this.element = document.createElement('div');
        this.element.className = 'animated-text-container';
        this.element.style.height = height + 'px';
    }
    AnimatedTextContainer.prototype.appendFromTop = function (element) {
        this.append(element, ' hidden-top');
    };
    AnimatedTextContainer.prototype.appendFromBottom = function (element) {
        this.append(element, ' hidden-bottom');
    };
    AnimatedTextContainer.prototype.append = function (element, hiddenClassName) {
        var e = new ElementToAdd();
        e.element = element;
        e.hiddenClassName = hiddenClassName;
        this.queue.push(e);
        if (!this.inProgress) {
            this.processQueue();
        }
    };
    AnimatedTextContainer.prototype.processQueue = function () {
        var _this = this;
        this.inProgress = true;
        var e = this.queue.pop();
        this.queue.length = 0;
        var element = e.element;
        var hiddenClassName = e.hiddenClassName;
        element.className = element.className.replace(' hidden-bottom', '').replace(' hidden-top', '');
        requestAnimationFrame(function () {
            element.className += hiddenClassName;
            _this.element.appendChild(element);
            requestAnimationFrame(function () {
                element.className = element.className.replace(hiddenClassName, ' visible');
                if (_this.previousElement != null) {
                    _this.previousElement.className = _this.previousElement.className.replace(' visible', hiddenClassName == ' hidden-top' ? ' hidden-bottom' : ' hidden-top');
                }
                setTimeout(function () {
                    if (_this.previousElement != null) {
                        _this.element.removeChild(_this.previousElement);
                    }
                    _this.previousElement = element;
                    if (_this.queue.length > 0) {
                        _this.processQueue();
                    }
                    else {
                        _this.inProgress = false;
                    }
                }, _this.animationDelay);
            });
        });
    };
    return AnimatedTextContainer;
}());
exports.AnimatedTextContainer = AnimatedTextContainer;
//# sourceMappingURL=animated-text-container.js.map